import { CategoryOrAnd } from "./value";

export const categoryOrAndOptions = Object.entries(CategoryOrAnd)
	.filter(([value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
